// extracted by mini-css-extract-plugin
export default {"error_popup":"ErrorPopup_error_popup__lZfzD","error_content":"ErrorPopup_error_content__qxCb-","hide":"ErrorPopup_hide__3SCoe"};